// Deprecated, import directly from the component folder now.
export * from '../../Autofill/Autofill.types';